"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const debounce_1 = __importDefault(require("lodash/debounce"));
const TextField_1 = __importDefault(require("../TextField/TextField"));
const SliderContext_1 = require("./SliderContext");
const SliderConstants_1 = require("./SliderConstants");
const VALUE_UPDATE_DELAY = 300;
function getCurrentLabel(isPostfix, ranged, value, valueText) {
    if (!ranged) {
        return [value, valueText];
    }
    if (isPostfix) {
        return [value[1], valueText[1]];
    }
    return [value[0], valueText[0]];
}
function parseValue(valueText) {
    return valueText.replace(/\D/g, "");
}
const SelectionIndicator = ({ kind = SliderConstants_1.InfixKind.PREFIX }) => {
    const isPostfix = kind === SliderConstants_1.InfixKind.POSTFIX;
    const { ranged, value, valueText } = (0, SliderContext_1.useSliderSelection)();
    const [, currentTextValue] = getCurrentLabel(isPostfix, ranged, value, valueText);
    const { changeThumbValue } = (0, SliderContext_1.useSliderActions)();
    const handleChange = (0, react_1.useMemo)(() => (0, debounce_1.default)(newValueText => {
        const newValue = parseValue(newValueText);
        const thumbIndex = isPostfix ? 1 : 0;
        changeThumbValue(newValue, thumbIndex, true);
    }, VALUE_UPDATE_DELAY), [changeThumbValue, isPostfix]);
    // @ts-ignore TODO TS-migration TextField not converted yet
    return (0, jsx_runtime_1.jsx)(TextField_1.default, { onChange: handleChange, value: currentTextValue });
};
exports.default = SelectionIndicator;
